<template>
  <img :src="url2" :alt="src" />
</template>

<script>
// src\components\Img2.vue
// 이미지 부하를 다른 데서 가져온다.
import { defineComponent } from "vue";

export default defineComponent({
  name: "Img2",
  props: {
    src: String,
    // cls: String,
  },
  computed: {
    url2() {
      if (this.src.indexOf("http") == 0) {
        console.error("im2 link fail", ret);
        return this.src;
      }

      const list = [
        //        "https://thisisone.github.io",
        //        "https://cflare-res.pages.dev",
        "https://gotothemetaverse.github.io",
      ];

      const max = list.length;
      var i = Math.floor(Math.random() * max);
      let ret = list[i] + this.src;
      return ret;
    },
  },
});
</script>
